import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib';
// import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import vueResource from 'vue-resource';
import './plugins/dateFormat'
import './plugins/modernizr'
import ImagenZoom from './components/ImagenZoom'

Vue.config.productionTip = false

Vue.use(vueResource);
Vue.use(Vuetify);
Vue.component('imagen-zoom', ImagenZoom);

new Vue({
  vuetify : new Vuetify({
    icons: {
        iconfont: 'fa'
    }
  }),
  router,
  render: h => h(App)
}).$mount('#app')


let metaColor = document.createElement('meta');
metaColor.name="theme-color";
metaColor.content="#1976d2";
document.head.appendChild(metaColor);
document.title = 'Pet Manager'